import { getBrandConfig } from 'config/brandConfig';

const isSupported = () => typeof window !== 'undefined' && 'Notification' in window;

export const requestNotificationPermission = async () => {
  if (!isSupported()) return 'unsupported';
  if (Notification.permission !== 'default') return Notification.permission;
  return Notification.requestPermission();
};

let permissionPromptArmed = false;
export const requestNotificationPermissionOnInteraction = () => {
  if (!isSupported() || Notification.permission !== 'default' || permissionPromptArmed) return;
  permissionPromptArmed = true;

  const events = ['click', 'keydown'];
  const ask = () => {
    events.forEach((e) => window.removeEventListener(e, ask, true));
    permissionPromptArmed = false;
    Notification.requestPermission();
  };
  events.forEach((e) => window.addEventListener(e, ask, true));
};

export const showDesktopNotification = (title, { body, tag, onClick } = {}) => {
  if (!isSupported() || Notification.permission !== 'granted') return;

  const { faviconHref } = getBrandConfig();
  const icon = `${process.env.PUBLIC_URL || ''}${faviconHref}`;

  const notification = new Notification(title, { body, tag, icon, badge: icon });

  notification.onclick = () => {
    window.focus();
    notification.close();
    if (onClick) onClick();
  };
};
